var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBeginner4(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 515,
    height: 290,
    viewBox: "0 0 515 290",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1511_24562)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 290,
    fill: "#90A8ED"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M214.197 51.5566C214.076 55.4996 211.9 61.7095 210.727 64.3751H231.498C230.76 63.4866 229.345 60.0863 228.983 53.166C228.53 44.5156 225.764 42.1519 220.333 42.1519C214.901 42.1519 214.348 46.6279 214.197 51.5566Z",
    fill: "#E7E5E4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M214.197 51.5566C214.076 55.4996 211.9 61.7095 210.727 64.3751H231.498C230.76 63.4866 229.345 60.0863 228.983 53.166C228.53 44.5156 225.764 42.1519 220.333 42.1519C214.901 42.1519 214.348 46.6279 214.197 51.5566Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M240.615 49.6764C236.518 49.9801 234.778 50.7511 234.778 50.7511C234.778 50.7511 229.727 57.3158 222.917 56.8999C218.211 60.4416 209.488 59.3342 209.488 59.3342C209.488 59.3342 203.216 63.2357 194.427 52.1528C193.127 50.5221 190.545 46.9337 189.142 44.9667C188.534 44.1116 187.547 43.6117 186.495 43.6164L183.955 43.635V13.9327L230.643 14.0682C233.74 14.0682 235.236 18.549 235.236 18.549C241.153 18.4463 242.304 24.3335 242.304 24.3335C242.304 24.3335 247.495 23.6793 248.529 29.0058C249.46 33.8044 250.344 49.0316 240.615 49.6764Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M183.955 13.9334V52.303H150.293V13.8353L183.955 13.9334Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M150.293 13.8347V57.9887H0.444943L0 13.6011L150.293 13.8347Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M183.955 43.6355H183.791",
    stroke: "#E2442F",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M242.303 24.3354C243.945 30.8721 244.534 45.9639 237.963 49.9775Z",
    fill: "#FF7051"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M242.303 24.3354C243.945 30.8721 244.534 45.9639 237.963 49.9775",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M235.236 18.5565C237.331 24.9717 237.963 46.5628 234.777 50.7586Z",
    fill: "#FF7051"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M235.236 18.5565C237.331 24.9717 237.963 46.5628 234.777 50.7586",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M215.518 14.0286C230.153 18.5514 226.818 51.716 222.917 56.907Z",
    fill: "#FF7051"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M215.518 14.0286C230.153 18.5514 226.818 51.716 222.917 56.907",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M200.652 37.157C204.455 42.3995 215.517 56.4259 209.488 59.3368Z",
    fill: "#FF7051"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M200.652 37.157C204.455 42.3995 215.517 56.4259 209.488 59.3368",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 26.9806C210.605 34.6526 208.912 49.4127 208.912 49.4127Z",
    fill: "#FF7051"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M209.221 26.9806C210.605 34.6526 208.912 49.4127 208.912 49.4127",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M254.764 99.2139H185.719V181.887H254.764V99.2139Z",
    fill: "black"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M248.332 106.913H192.148V175.733H248.332V106.913Z",
    fill: "white"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M200.054 112.544C200.466 113.712 199.876 114.987 198.894 115.338C197.912 115.684 196.78 115.02 196.364 113.852C195.952 112.684 196.481 111.693 197.435 111.268C198.45 110.815 199.643 111.376 200.054 112.544Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M206.818 131.262C207.229 132.43 206.64 133.705 205.658 134.056C204.676 134.401 203.544 133.738 203.127 132.57C202.716 131.402 203.244 130.411 204.199 129.986C205.209 129.533 206.406 130.098 206.818 131.262Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M202.287 139.489C202.623 140.446 202.142 141.493 201.332 141.778C200.528 142.063 199.597 141.516 199.256 140.558C198.919 139.601 199.354 138.788 200.135 138.437C200.968 138.068 201.945 138.531 202.287 139.489Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M212.206 113.254C212.023 114.59 210.901 115.548 209.867 115.408C208.833 115.267 208.146 114.067 208.328 112.73C208.511 111.394 209.446 110.684 210.489 110.735C211.593 110.787 212.388 111.917 212.206 113.254Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M226.214 113.337C226.097 111.992 226.981 110.809 228.019 110.721C229.057 110.632 229.997 111.646 230.114 112.991C230.231 114.337 229.474 115.234 228.445 115.416C227.35 115.608 226.33 114.683 226.214 113.337Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M196.037 121.963C195.462 120.743 195.883 119.328 196.823 118.884C197.768 118.44 198.998 119.071 199.573 120.29C200.149 121.51 199.751 122.612 198.848 123.14C197.894 123.701 196.613 123.182 196.037 121.963Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M207.553 122.463C206.617 121.491 206.571 120.019 207.324 119.295C208.077 118.576 209.442 118.777 210.378 119.753C211.313 120.73 211.285 121.898 210.598 122.683C209.863 123.519 208.488 123.435 207.553 122.463Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M218.374 122.977C217.649 121.842 217.892 120.384 218.771 119.828C219.651 119.268 220.951 119.739 221.676 120.875C222.401 122.01 222.144 123.155 221.316 123.79C220.436 124.468 219.099 124.117 218.374 122.977Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M220.588 133.13C219.863 131.995 220.003 130.603 220.775 130.112C221.547 129.622 222.758 130.15 223.483 131.285C224.208 132.42 224.035 133.509 223.315 134.079C222.547 134.682 221.313 134.266 220.588 133.13Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M224.179 142.119C223.361 141.535 223.108 140.484 223.548 139.867C223.987 139.255 225.002 139.227 225.821 139.811C226.639 140.395 226.789 141.241 226.41 141.895C226.003 142.587 224.993 142.703 224.179 142.119Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M203.982 152.623C203.314 151.731 203.487 150.46 204.249 149.89C205.011 149.32 206.176 149.577 206.85 150.469C207.523 151.362 207.322 152.366 206.606 153.002C205.844 153.67 204.651 153.516 203.982 152.623Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M205.761 162.281C205.845 161.057 206.753 160.113 207.641 160.178C208.53 160.239 209.18 161.286 209.091 162.51C209.003 163.734 208.245 164.44 207.356 164.463C206.407 164.486 205.672 163.51 205.761 162.281Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M215.577 153.436C214.576 153.249 213.907 152.31 214.066 151.473C214.221 150.637 215.161 150.114 216.162 150.301C217.163 150.488 217.654 151.268 217.565 152.114C217.471 153.011 216.578 153.623 215.577 153.436Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M241.237 153.865C240.185 153.669 239.525 152.468 239.731 151.365C239.937 150.263 240.956 149.525 242.009 149.721C243.061 149.917 243.543 150.917 243.407 152.034C243.262 153.216 242.285 154.061 241.237 153.865Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M220.516 150.81C220.951 149.702 222.172 149.137 223.098 149.497C224.019 149.857 224.417 151.048 223.987 152.155C223.552 153.263 222.551 153.66 221.601 153.375C220.586 153.076 220.081 151.922 220.516 150.81Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M222.267 163.155C222.369 161.534 223.384 160.272 224.376 160.333C225.363 160.394 226.083 161.758 225.98 163.379C225.877 165.001 225.026 165.944 224.035 165.996C222.978 166.052 222.164 164.776 222.267 163.155Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M240.237 162.635C240.747 161.262 242.037 160.463 242.964 160.804C243.894 161.145 244.236 162.542 243.726 163.916C243.216 165.289 242.164 165.864 241.205 165.616C240.185 165.355 239.732 164.014 240.237 162.635Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M229.693 142.316C229.104 141.573 229.178 140.531 229.773 140.059C230.367 139.587 231.321 139.811 231.91 140.549C232.499 141.292 232.392 142.119 231.84 142.638C231.255 143.189 230.282 143.058 229.693 142.316Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M230.723 133.293C230.727 131.948 231.593 130.85 232.505 130.855C233.417 130.859 234.156 131.953 234.151 133.298C234.146 134.644 233.417 135.471 232.505 135.56C231.541 135.658 230.718 134.644 230.723 133.293Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M241.186 132.471C241.19 131.275 241.981 130.298 242.818 130.303C243.655 130.307 244.329 131.279 244.329 132.475C244.324 133.672 243.655 134.405 242.823 134.485C241.934 134.569 241.181 133.672 241.186 132.471Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M232.48 122.401C232.48 121.546 233.509 120.079 234.66 120.074C235.815 120.07 236.812 121.546 236.812 122.383C236.812 123.728 235.895 124.56 234.744 124.653C233.523 124.761 232.48 123.752 232.48 122.401Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M202.51 110.549V116.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M203.486 118.487V124.071",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M196.223 128.874V134.458",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M196.389 137.756V143.339",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M206.584 137.756V143.339",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M210.602 138.601L210.948 143.727",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M215.189 137.896L215.194 143.04",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M196.219 148.507L196.228 153.652",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M196.379 159.745L196.388 164.884",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M211.758 159.771L211.772 166",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M215.619 159.309L215.628 165.813",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M218.889 158.622L218.903 166",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M200.299 148.507L200.308 154.446",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M211.215 149.353L211.224 154.782",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M218.965 139.063L219.049 143.175",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M227.509 148.979L226.85 154.548",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M231.896 148.048L232.051 153.655",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M229.676 159.506L229.83 165.117",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M233.539 159.314L233.197 164.916",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M236.798 159.949L236.461 165.551",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M235.705 148.96L235.859 154.567",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M235.779 138.886L235.863 142.997",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M243.754 138.615L243.838 142.727",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M240.066 138.475L240.151 143.727",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M199.23 129.201L199.469 134.78",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M211.111 128.659L211.078 134.242",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M216.323 129.196L216.285 134.78",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M226.996 129.929L226.963 135.512",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M238.172 129.706L238.135 135.812",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M215.209 118.487V124.071",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M205.596 110.549V116.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M215.967 110.549V116.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M219.502 110.549V116.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M223.365 110.549V116.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M225.109 118.552V124.135",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M229.355 118.757V124.341",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M239.961 118.757V124.341",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M243.496 118.762L243.814 124.336",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M238.393 110.549V116.132",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M201.653 159.771C201.653 159.771 198.529 161.93 199.408 163.916C200.46 166.294 202.832 164.486 202.935 163.192C203.094 161.178 201.092 160.056 201.092 160.056",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M234.815 110.688C234.815 110.688 231.691 112.847 232.57 114.833C233.622 117.211 235.994 115.403 236.097 114.109C236.256 112.095 234.254 110.973 234.254 110.973",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M243.963 114.913C245.123 114.913 246.063 114.126 246.063 113.156C246.063 112.185 245.123 111.399 243.963 111.399C242.804 111.399 241.863 112.185 241.863 113.156C241.863 114.126 242.804 114.913 243.963 114.913Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M301.831 199.173H128.787C126.28 188.815 118.217 187.077 118.217 187.077L119.035 185.287H311.364C301.513 188.436 301.831 199.173 301.831 199.173Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M315.203 187.072H106.373C105.536 187.072 104.857 186.395 104.857 185.559V183.4C104.857 182.564 105.536 181.886 106.373 181.886H315.203C316.04 181.886 316.718 182.564 316.718 183.4V185.559C316.718 186.395 316.04 187.072 315.203 187.072Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M176.555 224.863L176.279 254.72L176.148 268.568H138.402V224.863H176.555Z",
    fill: "white",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M138.403 224.863H0V276.194H138.403V224.863Z",
    fill: "black",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M155.893 264.97C157.647 264.97 159.068 263.55 159.068 261.798C159.068 260.046 157.647 258.625 155.893 258.625C154.139 258.625 152.717 260.046 152.717 261.798C152.717 263.55 154.139 264.97 155.893 264.97Z",
    fill: "black"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "darken"
    }
  }, _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M292.94 64.3766H132.192C124.236 64.3766 117.791 70.8198 117.791 78.7628V145.695H307.341V78.7628C307.341 70.8198 300.891 64.3766 292.94 64.3766Z",
    fill: "#E7E5E4"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M292.94 64.3766H132.192C124.236 64.3766 117.791 70.8198 117.791 78.7628V145.695H307.341V78.7628C307.341 70.8198 300.891 64.3766 292.94 64.3766Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M274.48 204.786C273.381 208.795 269.167 212.683 251.178 220.228C251.178 220.228 252.632 234.998 251.706 241.006C250.785 247.015 248.867 250.281 240.836 250.79C231.337 251.393 186.548 257.654 176.281 254.72L176.557 224.863C177.895 219.023 177.577 215.033 173.189 213.187C169.607 211.678 157.89 209.599 157.479 204.529C157.072 199.46 160.86 198.212 171.211 200.469C185.238 203.525 191.356 210.201 200.813 215.355C202.946 215.832 212.301 215.196 227.113 210.304C227.431 210.197 227.754 210.089 228.086 209.973C230.444 209.155 233.021 208.132 235.724 207.038C235.986 206.931 236.248 206.823 236.515 206.716C239.784 205.389 243.222 203.983 246.66 202.735C251.271 201.062 255.883 199.684 260.093 199.17C270.668 197.89 275.766 200.1 274.48 204.786Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M251.175 220.233C245.633 222.56 238.776 225.232 230.301 228.368",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M267.888 198.912C270.512 205.589 270.405 210.256 227.285 220.793",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M252.013 231.395C249.562 240.291 229.637 239.305 229.637 239.305",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M235.723 207.037C233.019 208.131 230.442 209.154 228.085 209.972C227.893 209.397 227.739 208.794 227.617 208.159C226.841 204.024 228.01 200.333 230.227 199.917C232.449 199.501 234.876 202.515 235.657 206.65C235.681 206.785 235.704 206.911 235.723 207.037Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M246.658 202.735C243.221 203.982 239.783 205.389 236.513 206.716C236.186 202.983 237.963 199.721 240.76 199.193C243.019 198.768 245.311 200.249 246.658 202.735Z",
    fill: "#FF7051",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M441.93 127.732H369.554L366.425 123.546L361.266 109.463L355.471 100.796L362.412 81.2234C362.412 81.2234 360.41 71.1918 368.974 68.4164C377.538 65.641 385.751 63.5664 390.971 67.1315C396.144 70.6638 401.336 75.7333 403.441 86.349L520.634 86.2976V127.732H441.93Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M313.276 30.858L360.666 19.7237C361.297 19.5742 361.956 19.7564 362.424 20.205C365.09 22.7701 374.005 31.956 377.368 43.1464C382.12 58.9624 383.701 72.2319 383.701 72.2319C383.701 72.2319 385.109 88.5058 392.232 108.625L366.793 115.708L351.377 109.606L345.783 99.1355L340.979 80.9413C340.979 80.9413 339.389 76.4511 338.074 74.1056C336.76 71.76 335.015 67.7651 331.19 64.3169C327.368 60.8687 324.436 57.3457 321.657 50.5521C319.258 44.6929 315.24 36.1658 312.635 32.5821C312.172 31.942 312.509 31.0402 313.276 30.858Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M319.77 33.4793L358.413 24.1532C358.413 24.1532 370.63 31.7598 377.36 66.5223C379.507 77.6099 384.942 97.1358 386.776 104.976L365.148 111.629L358.441 110.714L349.821 95.7808L345.186 81.1889C345.186 81.1889 341.944 71.4096 340.246 67.6904C338.549 63.9712 335.363 60.4809 330.747 57.3878C327.071 54.9161 319.77 33.4793 319.77 33.4793Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M326.57 42.0788L340.242 38.2007",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M338.315 41.6669C339.452 38.1953 336.86 36.5833 334.634 37.1627C332.403 37.7421 333.914 42.4285 331.678 42.9004C328.82 43.5078 327.314 40.5829 327.73 38.1953",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M362.497 77.177C351.346 79.13 346.299 72.4906 345.172 66.7903C344.41 62.9449 348.259 60.9919 350.981 60.1415C351.482 59.9826 351.945 59.8611 352.333 59.7724C353.212 59.5715 354.218 59.5247 355.186 59.6696C356.617 59.8845 357.979 60.5199 358.774 61.7161C359.092 62.1973 358.825 62.8468 358.25 62.9356C357.628 63.029 356.996 63.1038 356.36 63.1084C354.461 63.1178 352.562 62.5151 350.981 60.1415C350.944 60.0807 350.902 60.02 350.864 59.9593C348.114 55.628 351.482 51.1892 356.229 51.1892C360.977 51.1892 360.902 49.2642 361.861 46.5402C362.721 44.0965 366.234 42.5453 370.616 42.8116",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M356.359 63.1083L358.305 68.2666",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M359.57 73.2623C360.732 73.2623 361.674 72.0553 361.674 70.5663C361.674 69.0774 360.732 67.8704 359.57 67.8704C358.407 67.8704 357.465 69.0774 357.465 70.5663C357.465 72.0553 358.407 73.2623 359.57 73.2623Z",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M358.305 77.4149C358.094 76.9944 357.973 76.4945 357.973 75.9618C357.973 74.4713 358.917 73.2659 360.077 73.2659C361.242 73.2659 362.182 74.4713 362.182 75.9618C362.182 76.4104 362.098 76.8356 361.944 77.2094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M374.76 55.2594C373.062 58.516 368.768 61.6278 365.26 58.8571C361.752 56.0864 359.788 54.5679 356.771 55.6472C353.754 56.7265 353.815 59.1421 355.181 59.6748",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M369.484 61.7534C371.425 63.8186 372.178 67.3836 372.178 67.3836",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M385.398 65.2158C385.398 65.2158 372.62 65.5382 366.044 69.6406C359.468 73.7429 362.04 84.0549 362.569 90.2738C363.097 96.4927 365.618 101.375 369.748 99.483C373.878 97.5954 375.09 94.6378 376.198 89.1804C377.307 83.7231 376.469 79.2143 384.748 79.8123C388.504 80.2562 389.365 82.3868 389.435 84.4754C389.505 86.5639 393.92 85.6154 393.92 85.6154L395.394 81.3075L392.026 73.2663L385.398 65.2158Z",
    fill: "#23A094"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M443.655 86.3479H403.445C401.429 73.326 390.648 65.2708 385.428 65.3596C380.068 65.4484 368.581 66.6492 363.613 71.4617C359.769 75.1856 362.252 97.0524 366.064 99.0241C369.249 100.673 373.641 99.2951 375.727 91.4922C377.233 85.848 375.737 78.0965 386.448 80.0496C392.841 81.213 385.54 100.309 403.01 102.622",
    fill: "#FFC900"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M443.655 86.3479H403.445C401.429 73.326 390.648 65.2708 385.428 65.3596C380.068 65.4484 368.581 66.6492 363.613 71.4617C359.769 75.1856 362.252 97.0524 366.064 99.0241C369.249 100.673 373.641 99.2951 375.727 91.4922C377.233 85.848 375.737 78.0965 386.448 80.0496C392.841 81.213 385.54 100.309 403.01 102.622",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M362.935 86.2377C363.262 90.6204 354.591 92.2604 344.268 92.6575C333.852 93.0547 322.79 94.2087 324.193 86.1395C325.11 80.8551 334.497 79.6216 344.829 79.6216C355.161 79.6216 362.621 82.0512 362.935 86.2377Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M365.151 100.456C365.156 105.049 357.467 106.974 347.139 107.227C336.714 107.484 328.36 107.596 327.906 99.6387C327.574 93.7983 337.616 92.803 347.944 92.9806C358.271 93.1535 365.147 94.3823 365.151 100.456Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M371.477 123.482C371.804 128.902 364.48 129.658 356.533 129.378C347.941 129.074 341.15 129.99 340.78 123.29C340.504 118.375 348.788 117.534 357.305 117.678C365.822 117.823 371.248 119.748 371.477 123.482Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M370.148 113.575C370.148 117.159 362.309 119.701 353.324 119.911C343.642 120.135 336 120.556 335.574 113.342C335.261 108.048 344.592 107.151 354.185 107.314C363.778 107.478 370.148 108.758 370.148 113.575Z",
    fill: "#FFC900",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M341.492 141.715H384.237C384.714 141.715 385.056 142.177 384.906 142.63C384.022 145.312 381.581 153.816 381.075 167.006C380.458 183.093 390.229 183.588 381.852 218.192C381.777 218.505 381.492 218.734 381.169 218.734H347.395C346.964 218.734 346.642 218.356 346.702 217.935C347.526 212.366 344.485 203.39 343.325 200.381C342.109 197.222 336.604 188.181 338.517 174.365C340.131 162.74 344.083 157.138 340.809 142.579C340.711 142.135 341.038 141.715 341.492 141.715Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M351.315 214.991C350.894 214.991 350.557 214.664 350.529 214.243C350.141 208.151 347.732 201.394 346.82 199.03C346.605 198.469 346.315 197.839 345.983 197.11C344.149 193.101 340.735 185.639 342.227 174.874C342.666 171.711 343.293 168.977 343.901 166.342C345.253 160.474 346.544 154.872 345.314 146.363C345.244 145.887 345.608 145.457 346.09 145.457H379.205C379.715 145.457 380.089 145.929 379.972 146.424C378.901 150.928 377.68 157.852 377.334 166.866C377.096 173.042 378.265 177.205 379.392 181.228C381.296 188.008 383.256 195.003 378.896 214.379C378.817 214.739 378.494 214.996 378.125 214.996H351.315V214.991Z",
    fill: "#23A094",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M347.949 155.39H358.174",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M356.942 157.773C358.004 156.638 357.784 153.381 356.339 152.736C354.688 151.998 352.527 152.4 352.429 156.227C352.345 159.614 348.495 158.287 349.407 152.633",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M377.634 161.772C374.87 160.403 371.469 159.553 369.669 160.142C367.868 160.73 368.097 163.735 363.911 162.202C359.725 160.67 360.155 167.071 358.172 166.744C355.66 166.337 350.469 168.211 351.512 173.477C352.503 178.462 360.567 177.467 362.106 176.378C363.42 175.257 360.885 173.542 358.967 172.949C356.872 172.299 356.942 168.608 360.642 168.785C364.533 168.972 364.477 171.762 364.187 173.21C364.164 173.341 364.313 173.43 364.407 173.336C365.235 172.519 366.853 170.799 368.191 170.645C369.584 170.486 374.126 172.528 375.286 177.261C376.259 181.233 377.559 186.326 372.283 186.891C371.989 186.924 371.713 187.068 371.516 187.293C370.029 189.003 366.175 192.217 361.689 188.489C362.106 186.475 361.629 185.4 360.024 184.985C358.439 184.569 356.217 187.746 358.63 189.634C360.108 190.788 361.614 189.307 361.689 188.489",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M357.635 187.013C352.859 187.018 347.06 185.149 346.625 179.696C346.246 174.973 351.587 173.781 351.587 173.781",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M353.878 186.62C353.827 191.661 355.3 192.886 358.322 193.073C361.343 193.264 363.004 202.268 369.977 198.703C376.946 195.138 376.076 193.479 376.076 193.479",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M372.287 186.892C372.292 190.611 375.014 195.442 381.525 194.41",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M377.327 167.221C374.89 167.894 373.01 171.608 372.084 172.309",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M369.795 176.725C372.648 178.954 371.694 183.589 371.694 183.589",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M366.85 178.509C369.011 180.607 367.902 184.415 367.902 184.415",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M364.507 181.649C366.971 186.891 364.24 185.714 362.87 184.999C361.504 184.284 359.001 184.256 359.081 182.424C359.114 181.71 356.167 179.686 358.562 177.551C359.881 176.374 362.954 178.117 362.533 179.85C361.883 182.518 358.618 181.99 358.618 181.99",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M359.211 173.028V177.182",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M353.149 204.245C352.597 209.781 356.867 211.337 356.741 208.216C356.573 203.885 360.801 203.59 360.717 209.062",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M352.205 206.88L362.762 206.637",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M519.022 223.955V263.46C519.022 263.46 361.02 263.769 350.005 263.46C342.966 263.264 339.673 261.068 339.673 258.068C339.673 256.377 340.725 254.429 342.746 252.438C326.207 246.532 339.275 240.477 339.275 240.477C328.448 236.753 333.724 229.866 343.064 228.534C326.109 219.694 338.663 212.7 347.063 213.125C350.632 213.302 383.803 209.541 383.803 209.541C383.803 209.541 392.147 209.541 394.373 215.087C396.403 220.143 393.377 223.955 393.377 223.955H519.022Z",
    fill: "#FFC900"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M339.277 240.477C339.277 240.477 324.633 247.257 345.937 253.462Z",
    fill: "#FFC900"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M339.277 240.477C339.277 240.477 324.633 247.257 345.937 253.462",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M342.747 252.433C337.144 257.947 338.992 263.147 350.006 263.455C361.021 263.764 518.219 263.455 518.219 263.455V223.95H393.379C393.379 223.95 396.409 220.138 394.375 215.078C392.148 209.531 383.804 209.531 383.804 209.531C383.804 209.531 350.633 213.297 347.064 213.115C338.664 212.69 326.11 219.685 343.065 228.525C332.593 230.02 327.233 238.486 343.94 241.663",
    fill: "#FFC900"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M342.747 252.433C337.144 257.947 338.992 263.147 350.006 263.455C361.021 263.764 518.219 263.455 518.219 263.455V223.95H393.379C393.379 223.95 396.409 220.138 394.375 215.078C392.148 209.531 383.804 209.531 383.804 209.531C383.804 209.531 350.633 213.297 347.064 213.115C338.664 212.69 326.11 219.685 343.065 228.525C332.593 230.02 327.233 238.486 343.94 241.663",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M339.283 240.479C339.283 240.479 324.638 247.259 345.943 253.464Z",
    fill: "#FFC900"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M339.283 240.479C339.283 240.479 324.638 247.259 345.943 253.464",
    stroke: "black",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1511_24562"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 515,
    height: 290,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeginner4);
export default __webpack_public_path__ + "static/media/beginner4.06edd1cc7b085934ac5de5b5f68a8396.svg";
export { ForwardRef as ReactComponent };